import React from 'react';
import { Modal } from '@material-ui/core';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './dots.css';

import { feverColor } from '../../shared/temperature-color';
import { Content, Image, InfoContainer, TimeclockInfo, Temperature, Name, Date, SlideItem, CloseButton, CloseIcon } from './styles';
import { PrevArrow, NextArrow } from './custom-arrows';
import { base64ToPng } from '../../shared/images';


export default function ({
  open,
  onClose,
  name,
  details,
}) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="detalhes do registro térmico"
      aria-describedby="foto, nome, data do registro e temperatura"
    >
      <Content>
        <CloseButton onClick={onClose}>
          <CloseIcon />
        </CloseButton>
        <Slider {...settings}>
          {
            details && details.map(item => (
              <SlideItem>
                <Image src={base64ToPng(item.image)} />
                <InfoContainer>
                  <TimeclockInfo>
                    <Name>{name}</Name>
                    <Date color="textSecondary">{item.date}</Date>
                  </TimeclockInfo>

                  <Temperature color={feverColor(item.feverType)}>{item.temperature}°C</Temperature>
                </InfoContainer>
              </SlideItem>
            ))
          }
        </Slider>
      </Content>
    </Modal>
  );
}
